import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import Arrow from "../../assest/arrow.png";
import GeneralImg from "../../assest/Genera.png";
import EiquiepmentImg from "../../assest/Equipements.png";
import ManPowerImg from "../../assest/MAnPower.png";
import TranspiritionImg from "../../assest/Transportions.png";

const translations = {
  gb: {
    heading: "Our Services",
    paragraph:
      "Trusted contracting, skilled manpower, equipment rental, and transportation delivering quality, innovation, and client satisfaction.",
    viewMore: "View More",
    services: [
      {
        title: "General Contracting",
        desc: "Complete construction services with quality, expertise, integrity, and client satisfaction.",
      },
      {
        title: "Equipment Rental",
        desc: "Reliable equipment rentals for construction, industrial, and infrastructure project needs.",
      },
      {
        title: "Manpower Supply",
        desc: "Providing skilled, experienced workforce tailored to meet diverse project demands.",
      },
      {
        title: "Transportation Services",
        desc: "Efficient transport solutions ensuring timely delivery and smooth project operations.",
      },
    ],
  },
  sa: {
    heading: "خدماتنا",
    paragraph:
      "مقاولات موثوقة، عمالة ماهرة، تأجير معدات، وخدمات نقل بجودة وابتكار ورضا العميل.",
    viewMore: "عرض المزيد",
    services: [
      {
        title: "المقاولات العامة",
        desc: "خدمات إنشاء متكاملة بجودة وخبرة ونزاهة ورضا العميل.",
      },
      {
        title: "تأجير المعدات",
        desc: "تأجير معدات موثوقة لمشاريع البناء والصناعة والبنية التحتية.",
      },
      {
        title: "توفير القوى العاملة",
        desc: "توفير عمالة ماهرة ومجربة لتلبية متطلبات المشاريع المختلفة.",
      },
      {
        title: "خدمات النقل",
        desc: "حلول نقل فعالة لضمان التسليم في الوقت المناسب وسلاسة التنفيذ.",
      },
    ],
  },
  fr: {
    heading: "Nos Services",
    paragraph:
      "Contrats fiables, main-d'œuvre qualifiée, location d'équipement et transport de qualité, d'innovation et de satisfaction client.",
    viewMore: "Voir plus",
    services: [
      {
        title: "Entrepreneur Général",
        desc: "Services de construction complets avec qualité, expertise, intégrité et satisfaction client.",
      },
      {
        title: "Location d'Équipement",
        desc: "Location fiable d'équipements pour projets de construction, industriels et d'infrastructure.",
      },
      {
        title: "Fourniture de Main-d'œuvre",
        desc: "Main-d'œuvre qualifiée et expérimentée adaptée aux besoins divers des projets.",
      },
      {
        title: "Services de Transport",
        desc: "Solutions de transport efficaces assurant une livraison rapide et fluide.",
      },
    ],
  },
  de: {
    heading: "Unsere Dienstleistungen",
    paragraph:
      "Verlässliche Verträge, qualifiziertes Personal, Geräteverleih und Transport mit Qualität, Innovation und Kundenzufriedenheit.",
    viewMore: "Mehr anzeigen",
    services: [
      {
        title: "Allgemeine Bauarbeiten",
        desc: "Komplette Bauleistungen mit Qualität, Fachwissen, Integrität und Kundenzufriedenheit.",
      },
      {
        title: "Geräteverleih",
        desc: "Zuverlässiger Geräteverleih für Bau-, Industrie- und Infrastrukturprojekte.",
      },
      {
        title: "Personalbereitstellung",
        desc: "Bereitstellung qualifizierter Arbeitskräfte für unterschiedliche Projektanforderungen.",
      },
      {
        title: "Transportdienstleistungen",
        desc: "Effiziente Transportlösungen für pünktliche Lieferung und reibungslose Abläufe.",
      },
    ],
  },
};

const defaultServices = [
  {
    title: "General Contracting",
    desc: "Complete construction services with quality, expertise, integrity, and client satisfaction.",
    img: GeneralImg,
    path: "/general-contracting",
  },
  {
    title: "Equipment Rental",
    desc: "Reliable equipment rentals for construction, industrial, and infrastructure project needs.",
    img: EiquiepmentImg,
    path: "/equipment-rental",
  },
  {
    title: "Manpower Supply",
    desc: "Providing skilled, experienced workforce tailored to meet diverse project demands.",
    img: ManPowerImg,
    path: "/manpower-supply",
  },
  {
    title: "Transportation Services",
    desc: "Efficient transport solutions ensuring timely delivery and smooth project operations.",
    img: TranspiritionImg,
    path: "/Transport-services",
  },
];

const ServicesCard = ({
  showHeading = true,
  showParagraph = true,
  headingText,
  paragraphText,
  services = defaultServices,
  showCardTitle = true,
  showCardDescription = true,
  showCardButton = true,
}) => {
  const { language } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const langData = translations[language] || translations.gb;
  const serviceImages = [GeneralImg, EiquiepmentImg, ManPowerImg, TranspiritionImg];

  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        {showHeading && <h2 className="fw-bold">{headingText || langData.heading}</h2>}
        {showParagraph && (
          <p className="text-muted mx-auto" style={{ maxWidth: "600px", lineHeight: "1.6" }}>
            {paragraphText || langData.paragraph}
          </p>
        )}
        <div className="d-flex justify-content-center">
          <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e", marginTop: "8px" }} />
          <div style={{ width: "5px", height: "3px", backgroundColor: "#c8102e", margin: "8px 4px 0 4px" }} />
          <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e", marginTop: "8px" }} />
        </div>
      </div>

      <div className="row">
        {langData.services.map((service, index) => (
          <div className="col-12 col-sm-6 col-lg-3 mb-4" key={index}>
            <div
              className="card h-100 text-center border-0 service-card"
              style={{
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                borderRadius: "15px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div className="card-body d-flex flex-column align-items-center px-3 px-md-4">
                <img
                  src={serviceImages[index]}
                  alt={service.title}
                  className="mb-3 img-fluid"
                  style={{
                    height: "60px",
                    filter: "drop-shadow(0 2px 4px rgba(220, 38, 38, 0.5))",
                    transition: "filter 0.3s ease",
                    objectFit: "contain",
                  }}
                />
                {showCardTitle && <h5 className="card-title fw-semibold">{service.title}</h5>}
                {showCardDescription && (
                  <p className="card-text text-muted" style={{ flexGrow: 1, lineHeight: "1.5", fontSize: "0.92rem", marginBottom: "1rem" }}>
                    {service.desc}
                  </p>
                )}
                {showCardButton && (
                  <button
                    className="btn btn-outline-danger mt-auto rounded-pill d-flex align-items-center px-4 py-2 w-80 w-md-auto"
                    onClick={() => navigate(defaultServices[index].path)}
                  >
                    {langData.viewMore}
                    <img
                      src={Arrow}
                      alt="Arrow Icon"
                      className="ms-2"
                      style={{ width: "26px", height: "26px", transition: "transform 0.3s ease" }}
                    />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media (min-width: 768px) {
          .service-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3);
          }
          .service-card:hover img {
            filter: drop-shadow(0 4px 8px rgba(220, 38, 38, 0.8));
          }
          .btn-outline-danger:hover img {
            transform: translateX(5px);
          }
        }
      `}</style>
    </div>
  );
};

export default ServicesCard;
